import React, { Component } from 'react';
import './Emas.css';
import en from '../../../language/en/Emas.json';
import es from '../../../language/es/Emas.json';
import config from '../../../config/config.json';

class Emas extends Component {
	constructor() {
		super();
		this.state = {
			EmaGP: {},
			EmaContre: {}
		};

		window.scrollTo(0,1);
	}

	componentDidMount() {
		// Obteniendo los datos de la ema de la GP
		let url = `${config.apiBaseUrl}/ema/gp`;
		fetch(url)
		.then(
			res => {
				return res.json();
			}
		)
		.then(
			data => {
				// console.log('EmaGP = ', data);
				this.setState({
					EmaGP: data
				});
			}
		)
		.catch(
			err => {
				console.log("error ", err);
			}
		);

		// Obteniendo los datos de la ema de Contre
		url = `${config.apiBaseUrl}/ema/contre`;
		fetch(url)
		.then(
			res => {
				return res.json();
			}
		)
		.then(
			data => {
				// console.log('EmaContre = ', data);
				this.setState({
					EmaContre: data
				});
			}
		)
		.catch(
			err => {
				console.log("error ", err);
			}
		);
	}

	render() {
		return (
		  	<section id="emas">
	            <div className="pricing-bg">
					<div className="layer"></div>
	                <div className="container">
	                    <div className="heading">
	                        <h2><strong>Estaciones Meteorológicas Automáticas</strong></h2>
	                        <p >Adáptese a las condiciones climáticas <br /> usando la información del tiempo</p>
	                    </div>

	                    				
	                    <div className="row no-space-row">
	                        <div className="col-md-4">
	                            <div className="pricing no-right-brd">                                
									<span id="temp_contra">--.- °C</span>
	                                <h4>Estación Automática Contramaestre</h4>
	                                <span>---</span>
									<div className="desc"><p id="fecha_c">Última actualización:</p></div>
	                                 <ul className="pricing-features">                                   
	                                    <li className="fa fa-cloud"><p id="hum_contra">Húmedad:</p></li>
										<li className="fa  fa-umbrella"><p id="prec_contra">Precipitación:</p></li>
										<li className="fa fa-dashboard"><p id="pres_contra">Presión Atmosférica:</p></li>
										<li className="fa  fa-paper-plane"><p id="vel_contra">Velocidad del Viento:</p></li>
									</ul>
	                                <button id="bot1" type="button" className="btn-brd-primary" >Cargando...</button>								
	                            </div>
	                        </div>
	                        <div className="col-md-4">
	                            <div className="pricing pricing-red">
	                                <img src="assets/frontend/onepage2/img/widgets/partly_cloudy.png" alt="" />
									<span id="temp_stgo">--.- °C</span>
	                                <h4>Santiago de Cuba</h4>
	                                <span>Mayormente soleado</span>								
	                                <ul className="pricing-features">                                   
	                                    <li>Húmedad:</li>                                   
	                                    <li>Dirección del Viento:</li>
										 <li>Velocidad del Viento:</li>
	                                </ul>
	                                <button type="button" className="btn-brd-primary" ><a href="/forecast">Detalles...</a></button>
	                            </div>
	                        </div>
	                        <div className="col-md-4">
	                            <div className="pricing no-left-brd">                                
									<span id="temp_gran">--.- °C</span>
	                                <h4>Estación Automática Gran Piedra</h4>
	                                <span>---</span>
									<div className="desc"><p id="fecha_g">Última actualización:</p></div>
	                                 <ul className="pricing-features">                                   
	                                    <li className="fa fa-cloud"><p id="hum_gran">Húmedad:</p></li>
										<li className="fa  fa-umbrella"><p id="prec_gran">Precipitación:</p></li>
										<li className="fa fa-dashboard"><p id="pres_gran">Presión Atmosférica:</p></li>
										<li className="fa  fa-paper-plane"><p id="vel_gran">Velocidad del Viento:</p></li>
									</ul>
	                                 <button id="bot2" type="button" className="btn-brd-primary" >Cargando...</button>
	                            </div>
	                        </div>
	                    </div>
	                    
	                </div>
	            </div>
	        </section>
		);
	}
}

export default Emas;